<template>
  <div style="padding: 20px;">
    <ul style="width: 100%;text-align: center;margin-bottom: 0;list-style: none;padding-top: 4vh">
      <li class="summaryLi">
        <div>空间总数</div>
        <div><span class="summary blueColor">{{ summary.spaceCount ? summary.spaceCount : 0 }}</span>个</div>
      </li>
      <li class="summaryLi">
        <div>空间告警</div>
        <div><span class="summary redColor">{{ summary.spaceAlarmCount ? summary.spaceAlarmCount : 0 }}</span>个</div>
      </li>
      <li class="summaryLi">
        <div>设备总数</div>
        <div><span class="summary blueColor">{{ summary.deviceCount ? summary.deviceCount : 0 }}</span>个</div>
      </li>
      <li class="summaryLi">
        <div>设备告警</div>
        <div><span class="summary redColor">{{ summary.deviceAlarm ? summary.deviceAlarm : 0 }}</span>个</div>
      </li>
    </ul>

    <map-chart :data="data" :extend-data="extendData" ref="mapChart" style="height: 78vh;" :route="route"></map-chart>
  </div>
</template>

<script>
import MapChart from "@/components/echarts/MapChart1";
import {getDeviceSummary} from "@/network/device-info";
import {getProvinceSpace} from "@/network/space-info";

export default {
  name: "DeviceMap",
  components: {MapChart},
  data() {
    return {
      data: [],
      summary: {},
      extendData: null,
      route:'/overview'
    }
  },
  created() {
    this.getDeviceSummary();
  },
  methods: {
    init() {
      this.getDeviceSummary();
    },
    getData() {
      getProvinceSpace().then(res => {
        if (res.code === 0) {
          const data = res.data
          if (data.length > 0 && this.summary.spaceIdList.length > 0) {
            data.map(item => {
              if (item.citySpaceList.length > 0) {
                item.citySpaceList.map(city => {
                  if (city.spaceList.length > 0) {
                    city.spaceList.map(space => {
                      this.summary.spaceIdList.forEach(spaceId => {
                        if (space.id === spaceId) {
                          space.status = 1;
                          item.status = 1;
                        }
                        return space
                      })
                    })
                  }
                  return city
                })
              }
              return item
            })
          }
          this.data = res.data
        }
      })
    },
    getDeviceSummary() {
      getDeviceSummary().then(res => {
        if (res.code === 0) {
          this.summary = res.data
          this.getData();
        }
      })
    }
  }
}
</script>

<style scoped>
.summaryLi {
  width: 10%;
  display: inline-block;
}

.summary {
  font-size: 2.4rem;
  margin-right: 5px;
}

.blueColor {
  color: rgba(0, 227, 246, 1);
}

.redColor {
  color: rgba(255, 67, 76, 1);
}
</style>
